<template>
    <div class="enterPinCode" :class="{disabled: disabled}">
        <div class="title">
            <div v-html="title"></div>
           <slot></slot>
        </div>
        <div ref="inputs" class="enterCodeScreen_codeBlock" :class="{notValid: isError, focused: focused}"
              @keydown="downEvent">
            <input v-for="n in verifyCodeLength"
                   class="enterCodeScreen_input h2 pincodeInput"
                   type="text"
                   v-model="displayedCode[n-1]"
                   :disabled="disabled"
                   autocomplete="off"
                   maxlength="1"
                   inputmode="numeric"
                   @input.stop="inputEvent(n-1, $event)"
                   @paste="pasteEvent(n-1, $event)"
                   @focus="inputOnFocus"
                   @blur="focused=false"
            />
            <a class="btnIcon" @click="showCode = !showCode">
                <img v-if="showCode" src="../../assets/visibility-24px.svg" alt="" />
                <img v-else src="../../assets/visibility_off-24px.svg" alt="" />
            </a>
        </div>
        <div v-if="isError" class="validText">{{errorMessageText}}</div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import {resendSms as apiResendSms, sendCodeByCall as apiSendCodeByCall} from "../../helpers/api";
    import Profile from "../../helpers/profile";
    const CODE_LENGTH = 4;

    export default {
        name: "enterPinCode",
        components: {},
        props: {
            value: {type: String, default: ''},
            title: String,
            errorMessage: String,
            disabled: Boolean,
        },
        data() {
            return {
                verifyCodeLength: CODE_LENGTH,
                verifyCode: this.value.replace(/\D/g, '').split(''),
                displayedCode: this.value.replace(/\D/g, '').replace(/./g, '•').split(''),
                focused: false,
                isError: false,
                isErrorTimeout: null,
                errorMessageText: '',
                showCode: false,
            }
        },

        computed: {
            code: function () {
                 return this.verifyCode.join('');
            },

        },

        watch: {
            errorMessage: function (val) {
                if (val)
                    this.showError();
            },
            code: function (val) {
                this.$emit('input', val)
            },
            showCode: function (val) {
                if (val) {
                    this.displayedCode = this.verifyCode;
                } else {
                    this.displayedCode = this.verifyCode.join('').replace(/./g,'•').split('');
                }
            },
        },

        mounted () {
            if (this.value.length > 0)
                this.$refs.inputs.children[this.verifyCodeLength-1].focus();
        },

        methods: {
            focus: function () {
                this.$refs.inputs.children[0].focus();
            },

            inputEvent (index, event) {
                let value = event.target.value;
                value = value.replace(/\D/g, '');
                if (value.length > 1)
                    value = value.substr(0, 1);
                this.$set(this.verifyCode, index, value);
                this.displayedCode[index] = value.length > 0 ? (this.showCode ? value : "•") : '';
                if (!this.verifyCode[index].length)
                    return;
                this.nextElement(event);
            },
            nextElement (event) {
                let nextSibling = event.target.nextElementSibling;
                if (nextSibling) {
                    if (nextSibling.classList.contains('pincodeInput')) {
                        nextSibling.focus()
                    }
//                    else {
//                        Vue.nextTick(() => {
//                            if (this.code.length === this.verifyCodeLength)
//                                this.next();
//                        });
//                    }
                }
            },
            previousElement (event) {
                let previousSibling = event.target.previousElementSibling;
                if (previousSibling && previousSibling.classList.contains('pincodeInput'))
                    previousSibling.focus()
            },

            downEvent: function (event) {
                var keyCode = event.which || event.keyCode;
                if (keyCode === 8 && !event.target.value) {
                    this.previousElement(event);
                } else if (keyCode >= 37 && keyCode <= 41) {
                    event.preventDefault();
                    switch (keyCode) {
                        case 37:
                            this.previousElement(event);
                            break;
                        case 39:
                            this.nextElement(event);
                            break;
                    }
                }
            },

            pasteEvent: function (index, event) {
                if (event.clipboardData && event.clipboardData.getData) {
                    let pasteData = event.clipboardData.getData('Text');
                    let indexPaste = index || 0;
                    if (pasteData.length) {
                        pasteData = pasteData.split('');
                        pasteData.forEach(item => {
                            if (indexPaste >= this.verifyCodeLength) {
                                return;
                            }
                            item = item.replace(/\D/g, '');
                            if (item.length) {
                                this.$set(this.verifyCode, indexPaste, item);
                                this.displayedCode[indexPaste] = this.showCode ? item : "•";
                                indexPaste++;
                            }
                        })
                    }
                }
            },

            next: function () {
                if (this.code.length !== this.verifyCodeLength) {
                    this.showError(this.$ml.get('enterCodeValidationEmpty'));
                } else {
                    this.$emit('next', this.code)
                }
            },

            showError: function (message) {
                this.errorMessageText = message || this.errorMessage;
                this.isError = true;
                clearTimeout(this.isErrorTimeout);
                this.isErrorTimeout = setTimeout(() => {
                    this.errorMessageText = '';
                    this.isError = false;
                }, 3000); 
            },

            inputOnFocus: function (event) {
                this.focused = true;
                event.target.setSelectionRange(0, event.target.value.length);
            }

        },
    }
</script>

<style lang="scss" scoped>
    .enterPinCode {
        margin-top: 26px;
        position: relative;
        &.disabled {
            opacity: 0.5;
        }
        .title {
            font-weight: 300;
            font-size: 18px;
            line-height: 1.4em;
            color: #434343;
            text-align: left;
            margin-bottom: 12px;
        }
        .validText {
            position: absolute;
            left: 4px;
            top: 100%;
            font-weight: 500;
            font-size: 12px;
            line-height: 14px;
            margin: 4px 0 0;
            color: #E53935;
            text-align: left;
            max-width: 240px;
            padding-right: 5px;
        }
        .enterCodeScreen_codeBlock {
            height: 46px;
            display: flex;
            flex-direction: row;
            justify-content: left;
            align-self: center;
            max-width: 359px;
            .enterCodeScreen_input {
                width: 38px;
                height: 46px;
                margin: 0 8px;
                padding: 0 0 2px;
                border: 1px solid #BDD6E6;
                box-sizing: border-box;
                border-radius: 8px;
                color: #434343;
                text-align: center;
                box-shadow: none;
                -webkit-appearance: none;
                font-weight: 500;
                &:first-child {
                    margin-left: 0;
                }
                &:focus {
                    outline: none;
                }
            }
            &.focused input {
                border: 2px solid #5DC18B;
            }
            &.notValid input {
                border: 2px solid #EC3421;
            }
        }
    }
    .btnIcon {
        height: 24px;
        margin: 9px 4px;
        padding: 5px;
        cursor: pointer;
    }
    @media (min-width: 751px) {
        .enterPinCode {
            margin-top: 34px;
            .enterCodeScreen_codeBlock {
                height: 52px;
                .enterCodeScreen_input {
                    width: 46px;
                    height: 52px;
                }
            }

            .validText {
                width: auto;
            }
        }
    }

</style>